"use strict";

exports.__esModule = true;
exports.request = exports.newHeader = exports.init = exports.handleSubmitShortcut = exports.handleChangeUrl = exports.handleChangeHttpMethod = exports.handleChangeHeader = exports.handleChangeBody = exports.copyIdToken = void 0;
var _awsAmplify = require("aws-amplify");
var _uuid = _interopRequireDefault(require("uuid"));
var _axios = _interopRequireDefault(require("axios"));
var _actionTypes = require("./actionTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const init = data => {
  if (data.showDefaultShortcuts === true || !data.showDefaultShortcuts) {
    const shortcuts = [{
      name: 'Get all users',
      endpoint: '/users',
      useAuth: true
    }, {
      name: 'Get me',
      endpoint: '/users/me',
      useAuth: true
    }, {
      name: 'Get all groups',
      endpoint: '/groups',
      useAuth: true
    }, {
      name: 'Get me + flat perm.',
      endpoint: '/users/me?expand=FlatPermissions',
      useAuth: true
    }];
    let customShortcuts = [...shortcuts];
    if (data.shortcuts) customShortcuts.push(...data.shortcuts);
    data = {
      ...data,
      shortcuts: [...customShortcuts],
      endpoint: '',
      httpMethod: 'GET',
      headerKey: '',
      headerValue: '',
      body: '',
      isFetching: false,
      dataReturned: '',
      headers: [{
        id: _uuid.default.v4(),
        headerKey: '',
        headerValue: ''
      }]
    };
  }
  return dispatch => {
    dispatch({
      type: _actionTypes.INIT_APITESTER,
      data: data
    });
  };
};
exports.init = init;
const newHeader = () => {
  return dispatch => {
    dispatch({
      type: _actionTypes.NEW_HEADER_CREATED
    });
  };
};
exports.newHeader = newHeader;
const copyIdToken = () => dispatch => {
  _awsAmplify.Auth.currentSession().then(creds => {
    const token = creds.idToken.jwtToken;
    const authHeader = {
      id: _uuid.default.v4(),
      headerKey: 'Authorization',
      headerValue: token
    };
    dispatch({
      type: _actionTypes.ID_TOKEN_COPIED,
      data: authHeader
    });
    return Promise.resolve();
  }).catch(err => {
    dispatch({
      type: _actionTypes.ID_TOKEN_COPIED,
      data: err
    });
    return Promise.resolve();
  });
};
exports.copyIdToken = copyIdToken;
const handleChangeUrl = e => {
  return dispatch => {
    dispatch({
      type: _actionTypes.URL_KEY_PRESSED,
      data: e.target.value
    });
  };
};
exports.handleChangeUrl = handleChangeUrl;
const handleChangeHeader = (item, e) => {
  const header = {
    name: e.target.name,
    value: e.target.value,
    id: item.id
  };
  return dispatch => {
    dispatch({
      type: _actionTypes.HEADER_KEY_PRESSED,
      data: header
    });
  };
};
exports.handleChangeHeader = handleChangeHeader;
const handleChangeHttpMethod = e => {
  return dispatch => {
    dispatch({
      type: _actionTypes.HTTP_METHOD_CHANGED,
      data: e.target.value
    });
  };
};
exports.handleChangeHttpMethod = handleChangeHttpMethod;
const handleChangeBody = e => {
  return dispatch => {
    dispatch({
      type: _actionTypes.BODY_CHANGED,
      data: e.target.value
    });
  };
};
exports.handleChangeBody = handleChangeBody;
const handleSubmitShortcut = shortcut => {
  return dispatch => {
    dispatch({
      type: _actionTypes.SHORTCUT_SUBMITTED,
      data: shortcut
    });
  };
};
exports.handleSubmitShortcut = handleSubmitShortcut;
const request = (requestParams, headers) => {
  disableButtons();
  const headerAuth = _axios.default.defaults.headers.common['Authorization'];
  let interceptor = null;
  return dispatch => {
    try {
      delete _axios.default.defaults.headers.common['Authorization'];
      const instance = _axios.default.create();
      interceptor = setHeaders(instance, headers);
      instance.request(requestParams).then(res => {
        let str = JSON.stringify(res.data, null, 2);
        let hilited = syntaxHighlight(str);
        let status = "Status: " + res.status;
        document.getElementById("status").innerHTML = status;
        document.getElementById("response").innerHTML = hilited;
        enableButtons();
        dispatch({
          type: _actionTypes.SUCCESSFUL_REQUEST,
          data: res
        });
      }).catch(error => {
        //debugger;

        let status = "";
        document.getElementById("status").innerHTML = "";
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx

          if (error.response.status) {
            status = error.response.status;
            document.getElementById("status").innerHTML = "Status: " + status;
          }
          document.getElementById("response").innerHTML = "Error: The request was made and the server responded with\na status code that falls out of the range of 2xx.\n\n";
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js

          document.getElementById("response").innerHTML = "Error: The request was made but no response was received.\nCheck your authorization token and the endpoint.\n\n";
        } else {
          // Something happened in setting up the request that triggered an Error

          document.getElementById("response").innerHTML = "General error during request submitting, ensure that headers are correct.\n\n";
        }
        enableButtons();
        let str = JSON.stringify(error, null, 2);
        let hilited = syntaxHighlight(str);
        document.getElementById("response").innerHTML += hilited;
        dispatch({
          type: _actionTypes.SUCCESSFUL_REQUEST,
          data: error
        });
      });
    } catch (err) {
      if (err === "Duplicate headers") {
        document.getElementById("response").innerHTML = "Error: Duplicate headers. Each header must have a unique key.\n\n";
      }
      enableButtons();
      _axios.default.interceptors.request.eject(interceptor);
      dispatch({
        type: _actionTypes.SUCCESSFUL_REQUEST,
        data: err
      });
    } finally {
      _axios.default.defaults.headers.common['Authorization'] = headerAuth;
      enableButtons();
    }
  };
};
exports.request = request;
function setHeaders(instance, headers) {
  /**
   * Sets headers in state as default axios headers.
   * If key or value is empty, that header is ignored.
   */

  let items = [...headers];
  for (let i = 0; i < items.length; i++) {
    if (items[i].headerKey !== "") {
      instance.interceptors.request.use(config => {
        if (items[i].headerKey.length > 0) {
          config.headers[items[i].headerKey] = items[i].headerValue;
          return config;
        }
      }, error => {
        return Promise.reject(error);
      });
    }
  }
  const interceptor = instance.interceptors;
  return null;
}
function disableButtons() {
  let buttons = document.getElementsByClassName("btn-primary");
  for (let i = 0; i < buttons.length; i++) buttons[i].disabled = "disabled";
  document.getElementById("submitButton").disabled = "disabled";
  document.getElementById("submitButton").innerHTML = "<span className='spinner-grow spinner-grow-sm' role='status' aria-hidden='true'> </span>  Sending...";
}
function enableButtons() {
  let buttons = document.getElementsByClassName("btn-primary");
  for (let i = 0; i < buttons.length; i++) buttons[i].disabled = false;
  document.getElementById("submitButton").disabled = false;
  document.getElementById("submitButton").innerHTML = "Send";
}
function syntaxHighlight(json) {
  if (typeof json != 'string') {
    json = JSON.stringify(json, undefined, 2);
  }
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+]?\d+)?)/g, function (match) {
    var cls = 'number';
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        cls = 'key';
      } else {
        cls = 'string';
      }
    } else if (/true|false/.test(match)) {
      cls = 'boolean';
    } else if (/null/.test(match)) {
      cls = 'null';
    }
    return '<span className="' + cls + '">' + match + '</span>';
  });
}